import { FunctionComponent, useCallback, useEffect, useState } from 'react'
import { Button } from '@conexasaude/hero'

import Modal from '@/components/Modal'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useStyles } from './useStyles'
import { Collapsible } from '@/components/Collapsible'
import Icon from '@/components/HeroIcons'
import ProfileCard from '../../ProfileCard'
import { RenderIf } from '@/components/RenderIf'
import { ISpecialtyResponse } from '@/modules/Auth/auth-types'
import service from '../../../../Auth/auth-services'
import useIsFirstRender from '@/hooks/useIsFirstRender'
interface PropsSpecialtiesModal {
  name?: string
  type?: string
  clinic?: string
  photo?: string
  token?: string
}

const SpecialtiesModal: FunctionComponent<PropsSpecialtiesModal> = ({
  type,
  name,
  clinic,
  photo,
  token,
}) => {
  const { closeModal } = useModalContext()
  const isFirstRender = useIsFirstRender()
  const styles = useStyles()
  const [specialitiesWithDescription, setSpecialitiesWithDescription] =
    useState<ISpecialtyResponse[]>()

  const fetchSpecialties = useCallback(async () => {
    try {
      const specialties = await service.getSpecialties(token)
      const list: ISpecialtyResponse[] = specialties.map(spec => ({
        ...spec,
      }))
      setSpecialitiesWithDescription(list)
    } catch (err) {
      const errorMessage =
        err?.response?.data?.object?.msg ||
        err?.response?.data?.msg ||
        err.message
      return errorMessage
    }
  }, [token])

  useEffect(() => {
    if (isFirstRender) return

    fetchSpecialties()
  }, [isFirstRender, fetchSpecialties])

  return (
    <Modal id="SPECIALTIES_MODAL">
      <div css={styles.modalContainer}>
        <ProfileCard name={name} clinic={clinic} photo={photo} type={type} />
        <h4>Especialidades disponíveis para você:</h4>
        <section className="row">
          <div className="container-link">
            <Collapsible
              key={'Imeddiate'}
              title={'Atendimento Imediato'}
              openedIcon={<Icon name="arrow-up" width="24px" />}
              closedIcon={<Icon name="arrow-down" width="24px" />}
            >
              <p>
                Você pode realizar consulta imediata com clínico geral, para te
                ajudar no momento que precisar.
              </p>
            </Collapsible>
            {specialitiesWithDescription?.map(speciality => (
              <RenderIf
                key={speciality.id}
                condition={speciality?.atendimentoAgendado}
              >
                <Collapsible
                  title={speciality.descricao}
                  openedIcon={<Icon name="arrow-up" width="24px" />}
                  closedIcon={<Icon name="arrow-down" width="24px" />}
                >
                  <p>{speciality?.descricaoServico}</p>
                </Collapsible>
              </RenderIf>
            ))}
          </div>
        </section>
        <div css={styles.modalFooter}>
          <Button onClick={closeModal}>Entendi</Button>
        </div>
      </div>
    </Modal>
  )
}

export { SpecialtiesModal }
